import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=71416800&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=71416800&prod&scoped=true&lang=css&"
import style1 from "./edit.vue?vue&type=style&index=1&id=71416800&prod&lang=css&"
import style2 from "./edit.vue?vue&type=style&index=2&id=71416800&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71416800",
  null
  
)

export default component.exports